var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleNjoy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02238 7.46072C1.96543 7.46072 0.291992 5.78729 0.291992 3.73036C0.291992 1.67342 1.96543 0 4.02238 0C6.07933 0 7.75277 1.67342 7.75277 3.73036C7.75277 5.78729 6.07933 7.46072 4.02238 7.46072ZM4.02238 1.5524C2.82148 1.5524 1.84441 2.52947 1.84441 3.73036C1.84441 4.93125 2.82148 5.90831 4.02238 5.90831C5.22328 5.90831 6.20036 4.93125 6.20036 3.73036C6.20036 2.52947 5.22328 1.5524 4.02238 1.5524Z",
    fill: "url(#paint0_linear_32719_40769)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00132 10.1496C2.49231 10.1496 1.07129 9.56434 0 8.50166L1.09321 7.39957C1.87179 8.17192 2.90456 8.5972 4.00132 8.5972C5.09809 8.5972 6.16285 8.15904 6.94558 7.36328L8.05227 8.45189C6.9755 9.54657 5.5367 10.1496 4.00132 10.1496Z",
    fill: "url(#paint1_linear_32719_40769)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02272 4.61965C4.51367 4.61965 4.91166 4.22167 4.91166 3.73073C4.91166 3.23978 4.51367 2.8418 4.02272 2.8418C3.53178 2.8418 3.13379 3.23978 3.13379 3.73073C3.13379 4.22167 3.53178 4.61965 4.02272 4.61965Z",
    fill: "url(#paint2_linear_32719_40769)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32719_40769",
    x1: 4.02238,
    y1: 0,
    x2: 4.02238,
    y2: 7.46072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C4A4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32719_40769",
    x1: 4.02613,
    y1: 7.36328,
    x2: 4.02613,
    y2: 10.1496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C4A4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32719_40769",
    x1: 4.02272,
    y1: 2.8418,
    x2: 4.02272,
    y2: 4.61965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C4A4EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleNjoy);
export default __webpack_public_path__ + "static/media/purpleNjoy.9526b97e2670ec2881f14955a6fbd8fd.svg";
export { ForwardRef as ReactComponent };